module.exports = __webpack_public_path__ + "img/g-pay.4b61f69d.svg";